<template>
  <header class="process-header">
    <h1 class="process-title" :class="$platformClass">
      {{ languages.completeness }}
    </h1>
    <div class="infos-perfectness-box" :class="$platformClass">
      <i class="infos-perfectness-box-bg" :class="$platformClass"></i>
      <div
        class="infos-perfectness-move splite"
        :class="$platformClass"
        :style="styleLeft"
      >
        <span class="infos-perfectness-text" :class="$platformClass">
          {{ completion }}%
        </span>
      </div>
    </div>
    <p
      class="infos-text infos-p"
      :class="$platformClass"
      v-html="languages.completeTips"
    ></p>
  </header>
</template>

<script>
import languages from '../../store/languages';

export default {
  props: ['languages', 'completionLeft', 'completion'],
  computed: {
    styleLeft() {
      if (this.$isOmni) {
        return { width: this.completionLeft };
      }
      // RTL适配
      if (languages.isRtlDirection()) {
        return { right: this.completionLeft };
      }
      return { left: this.completionLeft };
    },
  },
};
</script>
